import { useState, useEffect } from "react";
import React from "react";
import {
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
  Font,
  StyleSheet,
  Image,
  PDFViewer,
} from "@react-pdf/renderer";

import { FontRegister, DocStyles, LogoTavad } from "./DocStyles";

import { FormatDate } from "./FormatDate";

import { useLoaderData, useParams } from "react-router-dom";

import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";

import hlaLogo from ".//images/hla-logo.png";

import servMedTavad from ".//images/servicio-medico-tavad-firma.jpg";

export function OtrosDocField({
  updateData,
  autoEspecialistaData,
  autoPacienteData,
  savedData,
}) {
  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  let especialistaFullName = autoEspecialistaData
    ? autoEspecialistaData?.first_name + " " + autoEspecialistaData?.last_name
    : undefined;
  let pacienteFullName = autoPacienteData
    ? autoPacienteData?.first_name + " " + autoPacienteData?.last_name
    : undefined;

  const [docResp, setDocResp] = useState(
    savedData?.docResp ? savedData?.docResp : especialistaFullName
  );
  const [docFecha, setDocFecha] = useState(
    savedData?.docFecha ? savedData?.docFecha : todayDate
  );
  const [docPacie, setDocPacie] = useState(
    savedData?.docPacie ? savedData?.docPacie : pacienteFullName
  );
  const [docDni, setDocDni] = useState(
    savedData?.docDni ? savedData?.docDni : autoPacienteData?.meta?.dni
  );
  const [docFechIngrRef, setDocFechIngrRef] = useState(
    savedData?.docFechIngrRef ? savedData?.docFechIngrRef : undefined
  );

  const [docNombreDocumento, setDocNombreDocumento] = useState(
    savedData?.docNombreDocumento ? savedData?.docNombreDocumento : undefined
  );

  let data = {
    docFecha: docFecha,
    docPacie: docPacie,
    docDni: docDni,
    docResp: docResp,
    docFechIngrRef: docFechIngrRef,
    docNombreDocumento: docNombreDocumento,
  };

  useEffect(() => {
    updateData(data);
  }, [docFecha, docPacie, docDni, docResp, docFechIngrRef, docNombreDocumento]);

  // Data for docx generator
  const [showDocxLink, setShowDocxLink] = useState(false);

  const generateDocx = async () => {
    try {
      const response = await fetch(
        "https://app.tavad.com/documentacion-templates/OtrosDoc.docx"
      );
      const blob = await response.blob();
      const arrayBuffer = await new Response(blob).arrayBuffer();

      const zip = new PizZip(arrayBuffer);
      const doc = new Docxtemplater(zip, {
        nullGetter() {
          return "XXXXXXXXX";
        },
      });

      doc.setData({
        date: FormatDate(docFecha),
        responsable: docResp,
        paciente: docPacie,
        dni: docDni,
        fechaIngrRefuerzo: FormatDate(docFechIngrRef),
        nombreDocumento: docNombreDocumento,
      });

      doc.render();
      const output = doc.getZip().generate({
        type: "blob",
        mimeType:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      saveAs(output, "otros-documentos.docx");
    } catch (error) {
      console.error("Error al generar el documento .docx", error);
    }
  };

  useEffect(() => {
    updateData(data);
    setShowDocxLink(true);
  }, [docResp, docFecha, docPacie, docDni, docFechIngrRef, docNombreDocumento]);

  return (
    <>
      <div className="docFormContainer">
        <div className="field">
          <label htmlFor="docNombreDocumento">Nombre del documento</label>
          <div className="control">
            <input
              className="input"
              id="docNombreDocumento"
              type="text"
              value={docNombreDocumento}
              onChange={(e) => setDocNombreDocumento(e.target.value)}
            />
          </div>
        </div>
        <div className="grid--2col">
          <div className="field">
            <label htmlFor="docFecha">Fecha</label>
            <div className="control">
              <input
                className="input"
                id="docFecha"
                type="date"
                value={docFecha}
                onChange={(e) => setDocFecha(e.target.value)}
              />
            </div>
          </div>
          <div className="field">
            <label htmlFor="docPacie">Paciente</label>
            <div className="control">
              <input
                className="input"
                id="docPacie"
                type="text"
                value={docPacie}
                onChange={(e) => setDocPacie(e.target.value)}
              />
            </div>
          </div>
          <div className="field">
            <label htmlFor="docDni">DNI Paciente</label>
            <div className="control">
              <input
                className="input"
                id="docDni"
                required
                type="text"
                value={docDni}
                onChange={(e) => setDocDni(e.target.value)}
              />
            </div>
          </div>
          <div className="field">
            <label htmlFor="docFechIngrRef">Fecha de inicio de ingreso</label>
            <div className="control">
              <input
                className="input"
                id="docFechIngrRef"
                required
                type="date"
                value={docFechIngrRef}
                onChange={(e) => setDocFechIngrRef(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
